export default "__VITE_PUBLIC_ASSET__87ebd689__"